import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { ColorThemeService } from '../../../../common/services/color-theme.service';
import { ThemeColor } from '../../../../common/enums/theme-color.enum';
import { ChartType } from '@iv/model/charts.model'
import {PaymentWindowService} from '../../../../payment-window.service';

@Component({
  selector: 'iv-live-charts-window',
  templateUrl: './charts-window.component.html',
  styleUrls: ['./charts-window.component.scss']
})
export class ChartsWindowComponent implements OnInit {

  constructor(
    private readonly colorThemeService: ColorThemeService,
    private readonly paymentWindowService: PaymentWindowService
  ) {
  }

  @Input() instrument;
  @Input() public ChartType: typeof ChartType = ChartType;

  type = 'atmIv';

  public colorTheme: ThemeColor;

  public ngOnInit(): void {
    this.paymentWindowService.showPaymentWindow();
    this.colorTheme = this.colorThemeService.getColorTheme();
  }

  changeChartType(type) {
    this.type = type;
  }

}
